import { IStairConfig, IStepGeometry } from '@stair-craft/common/util';

export function generateLandingStep(
    flight1Count: number,
    riserHeight: number,
    turnStartZ: number,
    config: IStairConfig,
    index: number
): IStepGeometry {
    return {
        index,
        riserHeight,
        position: { x: 0, y: (flight1Count + 1) * riserHeight, z: turnStartZ },
        treadWidth: config.stairWidth,
        treadDepth: config.stairWidth, // square: width × width
        treadThickness: config.treadThickness,
        noseLength: 0,
        rotation: 0,
        isWinder: false,
        isLanding: true,
    };
}
